import { render, staticRenderFns } from "./Damages.vue?vue&type=template&id=6120a125&scoped=true"
import script from "./Damages.vue?vue&type=script&lang=js"
export * from "./Damages.vue?vue&type=script&lang=js"
import style0 from "./Damages.vue?vue&type=style&index=0&id=6120a125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6120a125",
  null
  
)

export default component.exports